import { SiteType } from '@on3/api';
import { On3IconRivalsHighSchool } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import { On3Header } from '@on3/ui-lib/components/Svg/On3Header';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { Auth } from '@public/components/Header/Auth/Auth';
import { SiteLogo } from '@public/components/Image/SiteLogo';
import { useMemo } from 'react';

import styles from './SubscribeHeader.module.scss';

export const SubscribeHeader = () => {
  const { currentSite } = useSite();

  const isChannel = currentSite?.isChannel;
  const isHighSchool = currentSite?.type === SiteType.HighSchool;

  const siteVars = useMemo(
    () =>
      Object.entries({
        '--site-primary-color': currentSite?.primaryColor,
        '--site-link-color':
          currentSite?.linkColor || currentSite?.primaryColor,
      })
        .filter(([, v]) => !!v)
        .map(([k, v]) => `${k}: ${v};`)
        .join(' '),
    [currentSite],
  );

  return (
    <>
      <style>{`:root { ${siteVars}}`}</style>
      <header
        className={styles.header}
        style={{ backgroundColor: currentSite.primaryColor ?? '#3B4147' }}
      >
        <div className={styles.block}>
          {isChannel ? (
            <Link className={styles.logo} href={currentSite.url}>
              <On3Header
                height={30}
                secondaryFill={currentSite.primaryColor || '#000000'}
              />
              <span className={styles.teamName}>{currentSite.name}</span>
            </Link>
          ) : (
            <Link className={styles.logo} href={currentSite.url}>
              {isHighSchool ? (
                <On3IconRivalsHighSchool fill="#fff" />
              ) : (
                <SiteLogo height={30} />
              )}
            </Link>
          )}

          <div className={styles.authSection}>
            <Auth isSubscribe={true} />
          </div>
        </div>
      </header>
    </>
  );
};
